var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEquipmentEv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_equipment_ev",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "BG",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(0)",
    fill: "#dcf3ec"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5.8,12.059a5.97,5.97,0,0,1-1.451-.174,5.161,5.161,0,0,1-1.382-.568A13.754,13.754,0,0,1,4.84,7.011,17.064,17.064,0,0,1,7.751,3.7,13.61,13.61,0,0,0,4.013,6.5a16.322,16.322,0,0,0-2.572,3.563A6.438,6.438,0,0,1,.524,8.614,5.276,5.276,0,0,1,0,6.212,5.53,5.53,0,0,1,.394,4.238,6.1,6.1,0,0,1,1.833,2.174,5.621,5.621,0,0,1,3.923.9,13.8,13.8,0,0,1,6.614.222,21.046,21.046,0,0,1,9.457,0l.6,0c.711,0,1.372.012,1.965.037a29.429,29.429,0,0,1-.048,4.12A19.323,19.323,0,0,1,11.5,7.1a8.141,8.141,0,0,1-.742,1.974,5.577,5.577,0,0,1-.847,1.173,6.24,6.24,0,0,1-2,1.381A5.505,5.505,0,0,1,5.8,12.059Z",
    transform: "translate(5.966 5.971)",
    fill: "#1aad7f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEquipmentEv);
export default __webpack_public_path__ + "static/media/ic_equipment_ev.e3247bb8da7a5227ec89358c10ae792a.svg";
export { ForwardRef as ReactComponent };